module.exports = __webpack_public_path__ + "ath_game_web/img/8.1.22ec6d19.png";